import { useEffect, useState } from "react";
import { useNotifications } from "../useAPI";
import useNotificationStore from "../../stores/useNotificationStore";

const useNotificationsList = (isModalList) => {
  const [isFilteredByUnread, setFilterByUnread] = useState(false);

  let apiUrl = "/userNotifications/";
  if (isModalList) {
    apiUrl = `${apiUrl}shortList`;
  } else {
    apiUrl = `${apiUrl}${isFilteredByUnread ? "UNREAD" : "ALL"}`;
  }

  const hasUnreadNotifications = useNotificationStore((state) => state.hasUnread);
  const setLongList = useNotificationStore((state) => state.setLongList);
  const setShortList = useNotificationStore((state) => state.setShortList);
  const setHasUnread = useNotificationStore((state) => state.setHasUnread);

  const [{ data, loading: isFetching }, fetchLatest] = useNotifications(apiUrl, {
    manual: true,
  });

  const toggleFilter = () => {
    setFilterByUnread((prevState) => !prevState);
  };

  const content = {
    filterButtonName: isFilteredByUnread ? "Show all notifications" : "Filter by unread",
    filterButtonClass: isFilteredByUnread ? "selected" : "",
    iconColour: isFilteredByUnread ? "#fff" : "#37519D",
    filterMessage: isFilteredByUnread ? "Filtered by: unread" : null,
    noDataMsg: `You currently have no ${isFilteredByUnread ? "unread" : ""} notifications`,
  };

  useEffect(() => {
    const ac = new AbortController();
    if (!isFetching) {
      if (isModalList) {
        setShortList(data?.list);
      } else {
        setLongList(data?.list);
      }
      setHasUnread(data?.hasUnreadNotifications);
    }
    return () => ac.abort();
  }, [data, isFilteredByUnread]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchLatest();
      } catch (error) {
        console.error("Error fetching notifications", error);
      }
    };
    void fetchData();
  }, [isFilteredByUnread, hasUnreadNotifications]);

  return {
    isFetching,
    fetchLatest,
    toggleFilter,
    content,
  };
};

export default useNotificationsList;
